import toggle_class from "../dom/toggle_class"
import can_hover from "../features/can_hover"
import register_dom_update from "../navigation/register_dom_update"
import is_firefox from "../utils/is_firefox"

register_dom_update({
  after: () => {
    toggle_class(document.body, {
      "can-hover": can_hover(),
      "is-firefox": is_firefox(),
    })
  },
})
